// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

export const mininumBufferSize = 60;
export const defaultBufferSize = 60;
export const opsDailyCreditCapacity = 150;
export const rasterizationCredits = 5;

export const defaultLazPtSize = 1;
export const defaultDxfPtSize = 8;

// International foot (0.3048 m exactly) vs US survey foot (1200/3937 m, ~2 ppm larger) is a real
// distinction this app's own CAD file records track — not a rounding nicety. Using the wrong one
// silently mismatches a display value against the order's own deliverable by that fraction.
export const METRES_PER_INTERNATIONAL_FOOT = 0.3048;
export const METRES_PER_US_SURVEY_FOOT = 1200 / 3937;

export const projectTypes = ['standard', 'utilities', 'custom'];

export const utilitiesPackagesSubtypes = ['Underground (2D)', 'Aerial (3D)'];
export const aLaCartePackages = ['A la carte', 'Aerial A-la-carte', 'Underground A-la-carte'];

export const topoIntervals = [0.25, 0.5, 1, 2, 5, 10];

export const classification6Classes = [
  { name: 'Non-Ground', color: '#26C1FB', classId: 1 },
  { name: 'Ground', color: '#9BBCC8', classId: 2 },
  { name: 'Buildings', color: '#B2AFAB', classId: 3 },
  { name: 'Cars', color: '#FAA738', classId: 4 },
  { name: 'Vegetation', color: '#93BB25', classId: 5 },
  { name: 'Poles', color: '#788898', classId: 6 },
];

export const classification2Classes = [
  { name: 'Non-Ground', color: '#26C1FB', classId: 1 },
  { name: 'Ground', color: '#9BBCC8', classId: 2 },
];

export const classification6ClassesNew = [
  { name: 'Unclassified', color: '#9b9c9a', classId: 1 },
  { name: 'Ground', color: '#a87000', classId: 2 },
  { name: 'Vegetation', color: '#61b34f', classId: 5 },
  { name: 'Buildings', color: '#ff0000', classId: 6 },
  { name: 'Wires', color: '#000000', classId: 14 },
  { name: 'Pole and Telco Towers', color: '#489af7', classId: 15 },
  { name: 'Vegetation Buffer', color: '#eed202', classId: 25 },
];

export const defaultExpressAILayers = ['B-OVERHANG', 'R-PAVEMARK-LINE', 'R-ROAD', 'V-VEGETATION'];

export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const longMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const billingMethods = ['Pre-Pay Annually', 'Pre-Pay Quarterly', 'Pre-Pay Monthly', 'Monthly Usage Invoice', 'Project by Project'];

export const pricingDescription = [
  {
    name: 'no_commit',
    description: 'Pay as you go',
    displayName: 'Pay as you go',
  },
  {
    name: 'enterprise_pre_commit',
    description: 'Pay as you go',
    displayName: 'Enterprise Pre-commit',
  },
  {
    name: 'buy_monthly',
    description: 'Prepay 10% Off',
    displayName: 'Prepay Monthly',
  },
  {
    name: 'buy_quarterly',
    description: 'Prepay 20% Off',
    displayName: 'Prepay Quarterly',
  },
  {
    name: 'buy_upfront',
    description: 'Prepay 30% Off',
    displayName: 'Prepay Upfront',
  },
];

export const getLineWeights = (): number[] => {
  const lineWeight: number[] = [];
  for (let i = -3; i <= 100; i += 1) {
    lineWeight.push(i);
  }
  return lineWeight;
};

export const pricingTierLimits = [
  {
    lowerLimit: 0,
    upperLimit: 100,
  },
  {
    lowerLimit: 100,
    upperLimit: 200,
  },
  {
    lowerLimit: 200,
    upperLimit: 300,
  },
  {
    lowerLimit: 300,
    upperLimit: 600,
  },
  {
    lowerLimit: 600,
    upperLimit: 1200,
  },
  {
    lowerLimit: 1200,
    upperLimit: 3600,
  },
  {
    lowerLimit: 3600,
    upperLimit: 5000,
  },
  {
    lowerLimit: 5000,
    upperLimit: 6000,
  },
  {
    lowerLimit: 6000,
    upperLimit: 7000,
  },
  {
    lowerLimit: 7000,
    upperLimit: 8000,
  },
  {
    lowerLimit: 8000,
    upperLimit: 9000,
  },
  {
    lowerLimit: 9000,
    upperLimit: 10000,
  },
  {
    lowerLimit: 10000,
    upperLimit: 11000,
  },
  {
    lowerLimit: 11000,
    upperLimit: 12000,
  },
  {
    lowerLimit: 12000,
    upperLimit: 13000,
  },
  {
    lowerLimit: 13000,
    upperLimit: 14000,
  },
  {
    lowerLimit: 14000,
    upperLimit: 15000,
  },
  {
    lowerLimit: 15000,
    upperLimit: 16000,
  },
  {
    lowerLimit: 16000,
    upperLimit: 17000,
  },
  {
    lowerLimit: 17000,
    upperLimit: 18000,
  },
  {
    lowerLimit: 18000,
    upperLimit: 19000,
  },
  {
    lowerLimit: 19000,
    upperLimit: 20000,
  },
  {
    lowerLimit: 20000,
    upperLimit: 25000,
  },
  {
    lowerLimit: 25000,
    upperLimit: 30000,
  },
  {
    lowerLimit: 30000,
    upperLimit: 35000,
  },
  {
    lowerLimit: 35000,
    upperLimit: 50000,
  },
  {
    lowerLimit: 50000,
    upperLimit: 75000,
  },
  {
    lowerLimit: 75000,
    upperLimit: 100000,
  },
  {
    lowerLimit: 100000,
    upperLimit: 150000,
  },
  {
    lowerLimit: 150000,
    upperLimit: 10000000,
  },
];

export const licenseStatuses = ['N/A', 'License Fee Paid', 'Calculate on the fly'];

// Road-type groups offered in the Get Road Network dialog (AUT-6565). The road network Lambda
// returns the Overture road classes present in the area; the dialog shows a group when at least
// one of its classes is there and sends the checked groups' classes as roadTypes.
export interface IRoadNetworkGroup {
  key: string;
  label: string;
  description: string;
  classes: string[];
  defaultChecked: boolean;
}

export const ROAD_NETWORK_GROUPS: IRoadNetworkGroup[] = [
  {
    key: 'highways',
    label: 'Motorways and expressways',
    description: 'motorways, freeways, expressways, and other major national routes',
    classes: ['motorway', 'trunk'],
    defaultChecked: true,
  },
  {
    key: 'major',
    label: 'Major roads',
    description: 'main roads and arterial roads, including most state and regional highways',
    classes: ['primary', 'secondary'],
    defaultChecked: true,
  },
  {
    key: 'local',
    label: 'Local roads',
    description: 'local and residential streets, collector roads, and minor rural roads',
    classes: ['tertiary', 'residential', 'unclassified', 'living_street'],
    defaultChecked: true,
  },
  {
    key: 'access',
    label: 'Driveways and access roads',
    description: 'driveways, alleys, parking area lanes, and site access roads',
    classes: ['service'],
    defaultChecked: false,
  },
];

// 0 - created, 1 - order placed, 2 - order completed successfully, 3 - order failed, 4 - manual drafting starts, 5 - US QC begins, 6 - QC complete, 7 - manual output uploaded, 8 - canceled order and credit remitted)
export const orderStatusCode = {
  created: 0,
  processing: 1,
  autonomousSuccessful: 2,
  autonomousFailed: 3,
  manualDrafting: 4,
  usQc: 5,
  qcComplete: 6,
  done: 7,
  canceled: 8,
};

export const PROJECTS_SECTION_TITLE = <Record<string, string>>{
  all: 'All Projects',
  unassigned: 'Unassigned Projects',
  estimate: 'Estimated Projects',
  completed: 'Completed Projects',
  canceled: 'Canceled Projects',
  noLocation: 'Projects Without Location',
};

// Noun phrase for each filter, used in the "No ___ found for "query"" empty search message -
// e.g. unassigned -> "No unassigned projects found for...", estimate -> "No estimates found for...".
export const PROJECTS_NOT_FOUND_LABEL = <Record<string, string>>{
  all: 'projects',
  unassigned: 'unassigned projects',
  estimate: 'estimates',
  completed: 'completed projects',
  canceled: 'canceled projects',
  noLocation: 'projects without location',
};

export const LEDGER_TYPES = {
  order: 'order',
  subscription: 'subscription',
};

export const LEDGER_TYPE_TEXT = <Record<string, string>>{
  order: 'Order',
  subscription: 'Subscription Purchase',
};

// Whole-project refresh cadence for the customer and admin project pages. There is no
// push channel — this poll is what keeps file/EPSG state live while the page is open.
export const projectPollIntervalMs = 3000;

// A pending EPSG check older than this renders as failed. Deliberately long: point clouds
// can queue for EC2 capacity before the check even starts, and a 20 GB cloud takes real
// time to process. The state is derived at render time, so a result landing after the
// cutoff still replaces the failed state (nothing latches).
export const epsgCheckTimeoutMs = 10 * 60 * 60 * 1000;

// AUT-6465 — temporary, verbatim from Janan; delete with the delivery-estimate-notice flag
export const TURNAROUND_NOTICE_COPY = "We're improving how turnaround times are calculated. Your order date may be incorrect right now. Expect a corrected date from customer success representative soon.";
